import { Dispatch } from 'redux'
import { FormActions } from '../../reducers/form/actionNames'
import { ICreateFormActions } from './createFormActions'

export default function bindToReduxForm<P>(
  formActions: ICreateFormActions<P>,
  noSuccessPayload = false,
) {
  return (values: P, dispatch: Dispatch) =>
    new Promise((resolve, reject) =>
      dispatch({
        meta: {
          defer: { reject, resolve },
          formActions,
          noSuccessPayload,
        },
        payload: values,
        type: FormActions.Promise,
      }),
    )
}
